import { createContext, useEffect, useMemo, useReducer } from "react";
import { favoritesHandlers, favoritesInitialState, favoritesReducer } from "../reducers/FavoritesReducer";
import { useFavorites } from "./useHelpers/useFavorites";

export const FavoritesContext = createContext();

const FavoritesProvider = (props) => {

  const initState = favoritesInitialState({})
  const [favorites_state, favorites_dispatch] = useReducer(favoritesReducer, initState);

  const favorites_handlers = useMemo(
    () => favoritesHandlers(favorites_dispatch),
    [favorites_dispatch]
  );

  const { updateAppUserFav, getAppUserFavs } = useFavorites()

  useEffect(() => {
    const loadFavorites = async () => {
      const favs = await getAppUserFavs()
      favorites_handlers.ammendFavorites(favs)
    }
    loadFavorites()
  }, [getAppUserFavs])

  return <FavoritesContext.Provider value={{
    favorites_state,
    favorites_handlers,
  }}>
    {props.children}
  </FavoritesContext.Provider>

}

export default FavoritesProvider